import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import InterestContext from "../../context/interest/interestContext";
import RegistrationContext from "../../context/registration/registrationContext";

const FormLayout = ({ children }) => {
  // Get SiteProgram data from InterestContext
  const interestCtx = useContext(InterestContext);
  const { Siteprogram: interestSiteProgram } = interestCtx;
  const interestBrandName =
    interestSiteProgram &&
    interestSiteProgram.charter &&
    interestSiteProgram.charter.brand.brandName;

  // Get SiteProgram data from RegistrationContext
  const regCtx = useContext(RegistrationContext);
  const { Siteprogram } = regCtx;
  const regBrandName =
    Siteprogram &&
    Siteprogram.charter &&
    Siteprogram.charter.brand.brandName;

  
  const title = interestBrandName
    ? `${interestBrandName} | Enrollments`
    : regBrandName
    ? `${regBrandName} | Enrollments`
    : "Student Enrollment";

  return (
    <section id="enrollement-interest-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
      </Helmet>
      {/* <div className="info-header">
        <div className="container">
          <div className="call">
            <p></p>
          </div>
        </div>
      </div> */}
      {children}
    </section>
  );
};

export default FormLayout;
